var viewer_rtlignore_default = {
  "gallery_container": "ngZyz",
  "imageTitleContainer": "_1acAo",
  "clickableItem": "AGeqp",
  "prerender": "auf29",
  "expandContainer": "To1yS",
  "expandIcon": "pDPZO",
  "itemOverlay": "_15kVL",
  "imageTitle": "xgmf3",
  "pointer": "X0bJ4",
  "fadeIn": "F-VTS",
  "changing_background": "i8K3-"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
